import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { applyModelsThunk } from "../store/slices/fileSlice";
import { resetPerformanceSummaryCache } from "./usePerformanceSummary";
import { useRef } from "react";

export const useDataReviewLogic = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const abortRef = useRef(null);

  const processResponse = useSelector((s) => s.file?.processResponse);
  const applying = useSelector((s) => s.file?.applying);
  const applyResponse = useSelector((s) => s.file?.applyResponse);

  const hasProcessResponse = processResponse?.columns?.length > 0 ||
    processResponse?.numeric_columns?.length > 0 ||
    processResponse?.all_columns?.length > 0;

  const onBack = () => navigate("/dashboard/data-entry");
  const onBackToDashboard = () => navigate("/dashboard/anamoly-detection/analytic-dashboard");

  const onConfigure = async (payload) => {
    const fileName = processResponse?.file_name || processResponse?.fileName;
    if (!fileName) {
      message.error("No file_name available to apply models.");
      return;
    }

    try {
      const promise = dispatch(applyModelsThunk({ ...payload, file_name: fileName }));
      abortRef.current = promise;
      const result = await promise.unwrap();
      // console.log("apply result:", result);
      if(result?.success === true || result?.status === "success"){
        resetPerformanceSummaryCache();
        message.success("Models applied successfully.");
      }else{
        throw new Error(result?.message || "Apply models failed");
      }
    } catch (err) {
      if (err.name === "AbortError" || err.message === "Aborted") {
        console.log("Request cancelled");
        return;
      }
      console.error("apply failed:", err);
      message.error(err?.message || "Apply models failed");
    } finally {
      abortRef.current = null;
    }
  };

  const onCancel = () => {
    if (abortRef.current) {
      abortRef.current.abort();
      abortRef.current = null;
      message.info("Processing cancelled.");
    }
  };

  return {
    processResponse,
    applying,
    applyResponse,
    hasProcessResponse,
    onBack,
    onConfigure,
    onBackToDashboard,
    onCancel
  };
};
